import type { Event } from 'models';
import { BookmarkFillIcon, BookmarkLineIcon, Button } from 'ui';
import { useBookmarkObjectMutation, useUnbookmarkObjectMutation } from '../queries';

type P = {
  event: Event;
};

const NodeBookmarkButton = ({ event }: P) => {
  const { isPending: isBookmarking, mutate: bookmark } = useBookmarkObjectMutation();
  const { isPending: isUnbookmarking, mutate: unbookmark } = useUnbookmarkObjectMutation();

  const handleBookmark = (item: Event) => {
    item.isBookmarked ? unbookmark({ event: item, type: 'node' }) : bookmark({ event: item, type: 'node' });
  };

  return (
    <Button
      icon={event.isBookmarked ? <BookmarkFillIcon /> : <BookmarkLineIcon />}
      loading={isBookmarking || isUnbookmarking}
      onClick={() => {
        handleBookmark(event);
      }}
      type="link-secondary"
    />
  );
};

export default NodeBookmarkButton;
